// =========================================================
// js/superadmin.js - Master-Control & Founder Insights (V14.0)
// =========================================================
/**
 * 1. DAS MASTER-RANKING (Hauptseite / Global Ranking)
 */ window.renderSuperAdminDashboard = function() {
    if (!window.superPeriod) window.superPeriod = 'month';
    const allCompanyData = window.globalCompanyStats || [];
    return `
        <div class="p-8 lg:p-12 animate-fadeIn max-w-[1600px] mx-auto">
            <div class="flex flex-col md:flex-row justify-between items-end gap-6 mb-12">
                <div>
                    <div class="flex items-center gap-3 mb-2">
                        <div class="bg-rose-500 text-white p-2 rounded-lg shadow-lg shadow-rose-500/20">
                            <i data-lucide="shield-alert" class="w-5 h-5"></i>
                        </div>
                        <span class="text-[10px] font-black text-rose-500 uppercase tracking-[0.3em]">System-Masterzugriff</span>
                    </div>
                    <h2 class="text-5xl font-black text-slate-800 dark:text-slate-100 tracking-tighter">Globales Ranking</h2>
                </div>

                <div class="flex bg-slate-100 dark:bg-slate-800 p-1.5 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-inner">
                    ${[
        'month',
        'year',
        'all'
    ].map((p)=>`
                        <button onclick="window.superPeriod='${p}'; window.render();" 
                            class="px-6 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${window.superPeriod === p ? 'bg-white dark:bg-slate-700 shadow-sm text-blue-600 dark:text-blue-400' : 'text-slate-400'}">
                            ${p === 'month' ? '30 Tage' : p === 'year' ? '2026' : 'Gesamt'}
                        </button>
                    `).join('')}
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
                <div class="bg-slate-900 dark:bg-black p-10 rounded-[3rem] text-white shadow-2xl relative overflow-hidden group border border-slate-800">
                    <i data-lucide="zap" class="absolute -right-8 -top-8 w-40 h-40 opacity-10 group-hover:rotate-12 transition-transform duration-700"></i>
                    <p class="text-blue-400 text-[10px] font-black uppercase tracking-widest mb-4">Aktive Unternehmen</p>
                    <h4 class="text-7xl font-black tracking-tighter">${allCompanyData.length}</h4>
                </div>

                <div class="bg-white dark:bg-slate-900 p-10 rounded-[3rem] border border-slate-200 dark:border-slate-800 shadow-sm">
                    <p class="text-slate-400 dark:text-slate-500 text-[10px] font-black uppercase tracking-widest mb-4">CO2 gespart (Global)</p>
                    <div class="flex items-end gap-3">
                        <h4 class="text-6xl font-black text-slate-800 dark:text-slate-100 tracking-tighter">${window.getTotalGlobalCO2()}</h4>
                        <span class="text-xl font-bold text-emerald-500 mb-2">kg</span>
                    </div>
                </div>

                <div class="bg-blue-600 p-10 rounded-[3rem] text-white shadow-xl relative overflow-hidden">
                    <i data-lucide="activity" class="absolute -right-8 -bottom-8 w-40 h-40 opacity-20"></i>
                    <p class="text-blue-100 text-[10px] font-black uppercase tracking-widest mb-4">Engagement-Rate</p>
                    <h4 class="text-6xl font-black tracking-tighter">${window.getGlobalEngagement()}%</h4>
                    <p class="text-[10px] font-bold uppercase mt-2 opacity-80">Systemweite Aktivit\xe4t</p>
                </div>
            </div>

            <div class="bg-white dark:bg-slate-900 rounded-[3.5rem] border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden">
                <div class="p-10 border-b dark:border-slate-800 flex justify-between items-center bg-slate-50/50 dark:bg-slate-800/30">
                    <div>
                        <h3 class="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tight">Performance-Leaderboard</h3>
                        <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-1">Metriken f\xfcr Churn-Pr\xe4vention & ESG-Benchmarking</p>
                    </div>
                </div>
                <div class="overflow-x-auto">
                    <table class="w-full text-left">
                        <thead>
                            <tr class="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em] bg-slate-50 dark:bg-slate-800/50">
                                <th class="p-8">Unternehmen</th>
                                <th class="p-8 text-center">Modern Work (d/Kopf)</th>
                                <th class="p-8">CO2 Potenzial (%)</th>
                                <th class="p-8 text-center">Trust Score</th>
                                <th class="p-8 text-right">Engagement</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y dark:divide-slate-800">
                            ${allCompanyData.length === 0 ? `<tr><td colspan="5" class="p-20 text-center text-slate-400 font-bold">Warte auf Daten-Synchronisation...</td></tr>` : allCompanyData.sort((a, b)=>(parseFloat(b.totalCO2) || 0) - (parseFloat(a.totalCO2) || 0)).map((comp, idx)=>{
        const totalDays = parseFloat(comp.totalDays) || 0;
        const userCount = parseInt(comp.userCount) || 1;
        const mwIndex = (totalDays / userCount).toFixed(1);
        const co2Eff = comp.hoRate || 0;
        const engagement = comp.engagement || 0;
        const trustLevel = comp.trustLevel || 'Standard';
        return `
                                <tr class="hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors group">
                                    <td class="p-8">
                                        <div class="flex items-center gap-4">
                                            <span class="w-8 h-8 rounded-full flex items-center justify-center font-black text-[10px] ${idx < 3 ? 'bg-amber-100 text-amber-600' : 'bg-slate-100 dark:bg-slate-800 text-slate-400'}">
                                                ${idx + 1}
                                            </span>
                                            <div>
                                                <p class="font-black text-slate-800 dark:text-slate-100 text-lg leading-tight">${comp.name}</p>
                                                <p class="text-[10px] text-slate-400 font-bold uppercase tracking-tighter">${comp.industry || 'DIVERS'}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="p-8 text-center">
                                        <div class="flex flex-col items-center">
                                            <span class="text-2xl font-black text-blue-600 dark:text-blue-400">${mwIndex}</span>
                                            <span class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Tage / Kopf</span>
                                        </div>
                                    </td>
                                    <td class="p-8">
                                        <div class="flex flex-col gap-2">
                                            <div class="w-32 h-2 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                                                <div class="h-full bg-emerald-500" style="width: ${co2Eff}%"></div>
                                            </div>
                                            <span class="text-[10px] font-black text-emerald-600 uppercase">${co2Eff}% NUTZUNG</span>
                                        </div>
                                    </td>
                                    <td class="p-8 text-center">
                                        <span class="px-4 py-2 rounded-2xl text-[9px] font-black uppercase tracking-widest ${trustLevel === 'High Trust' ? 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400' : 'bg-slate-100 dark:bg-slate-800 text-slate-500'}">
                                            ${trustLevel}
                                        </span>
                                    </td>
                                    <td class="p-8 text-right">
                                        <div class="inline-block">
                                            <span class="text-2xl font-black ${engagement < 30 ? 'text-rose-500 animate-pulse' : 'text-slate-800 dark:text-slate-100'}">
                                                ${engagement}%
                                            </span>
                                            <p class="text-[9px] font-bold text-slate-400 uppercase tracking-widest">AKTIVIT\xc4T</p>
                                        </div>
                                    </td>
                                </tr>
                            `;
    }).join('')}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `;
};
/**
 * 2. SYSTEM-STATS (Die Seite, die den Fehler verursacht hat)
 */ window.renderSuperStatsHTML = function() {
    if (!window.superStartDate) {
        const now = new Date();
        window.superStartDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
        window.superEndDate = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];
    }
    const stats = window.calculateGlobalSuperImpact(window.superStartDate, window.superEndDate);
    return `
        <div class="p-8 lg:p-12 animate-fadeIn max-w-[1600px] mx-auto">
            <div class="flex flex-col md:flex-row justify-between items-center gap-6 mb-12">
                <div>
                    <h2 class="text-4xl font-black text-slate-800 dark:text-slate-100 tracking-tighter">System-Statistiken</h2>
                    <p class="text-slate-400 dark:text-slate-500 font-bold uppercase tracking-widest text-[10px] mt-1">Firmen\xfcbergreifende CSRD-Analyse</p>
                </div>

                <div class="flex items-center gap-3 bg-white dark:bg-slate-900 p-4 rounded-[2rem] border border-slate-200 dark:border-slate-800 shadow-sm">
                    <div class="flex flex-col">
                        <label class="text-[9px] font-black text-slate-400 uppercase ml-2 mb-1">Von</label>
                        <input type="date" value="${window.superStartDate}" 
                            onchange="window.superStartDate = this.value; window.render()"
                            class="bg-slate-50 dark:bg-slate-800 border-none rounded-xl px-4 py-2 font-bold text-sm text-slate-700 dark:text-slate-200 outline-none">
                    </div>
                    <div class="flex flex-col">
                        <label class="text-[9px] font-black text-slate-400 uppercase ml-2 mb-1">Bis</label>
                        <input type="date" value="${window.superEndDate}" 
                            onchange="window.superEndDate = this.value; window.render()"
                            class="bg-slate-50 dark:bg-slate-800 border-none rounded-xl px-4 py-2 font-bold text-sm text-slate-700 dark:text-slate-200 outline-none">
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
                ${window.renderMasterStatCard("Total CO2 Reduktion", stats.totalCO2.toFixed(1) + " kg", "wind", "emerald")}
                ${window.renderMasterStatCard("HO-Tage (System)", stats.totalDays, "home", "blue")}
                ${window.renderMasterStatCard("Kraftstoff-Ersparnis", stats.totalMoney.toFixed(2) + " \u20AC", "wallet", "amber")}
                ${window.renderMasterStatCard("Aktive User", stats.totalUsers, "users", "purple")}
            </div>
        </div>
    `;
};
/**
 * 3. HILFSFUNKTIONEN
 */ window.renderMasterStatCard = function(title, value, icon, color) {
    return `
        <div class="bg-white dark:bg-slate-900 p-8 rounded-[2.5rem] border border-slate-100 dark:border-slate-800 shadow-sm transition-all hover:border-blue-500/50">
            <div class="w-12 h-12 bg-${color}-100 dark:bg-${color}-900/30 text-${color}-600 dark:text-${color}-400 rounded-2xl flex items-center justify-center mb-6">
                <i data-lucide="${icon}"></i>
            </div>
            <p class="text-slate-400 dark:text-slate-500 text-[10px] uppercase font-black tracking-widest mb-1">${title}</p>
            <p class="text-3xl font-black text-slate-800 dark:text-slate-100 tracking-tighter">${value}</p>
        </div>
    `;
};
window.calculateGlobalSuperImpact = function(start, end) {
    const evs = window.events || [];
    const results = {
        totalCO2: 0,
        totalDays: 0,
        totalMoney: 0,
        totalUsers: 0
    };
    const userSet = new Set();
    evs.forEach((e)=>{
        if (e.date >= start && e.date <= end && e.status === 'APPROVED' && (e.type === 'HO' || e.type === 'homeoffice')) {
            results.totalCO2 += parseFloat(e.co2SavedAtBooking) || 0;
            results.totalDays++;
            results.totalMoney += 4.50;
            userSet.add(e.userId);
        }
    });
    results.totalUsers = userSet.size;
    return results;
};
window.getTotalGlobalCO2 = function() {
    return (window.globalCompanyStats || []).reduce((sum, c)=>sum + (parseFloat(c.totalCO2) || 0), 0).toFixed(1);
};
window.getGlobalEngagement = function() {
    const comps = window.globalCompanyStats || [];
    if (comps.length === 0) return "0.0";
    const avg = comps.reduce((sum, c)=>sum + (parseFloat(c.engagement) || 0), 0) / comps.length;
    return avg.toFixed(1);
};

//# sourceMappingURL=frontend.d0c7b15c.js.map
